import React from 'react';
import './style.scss';
import { localeStore } from '../../../mobx/localesStore';
import { formatPrice, getTranslate } from 'src/utils/formatter';
import Skeleton from 'react-loading-skeleton';
import { SCREENS } from '../../../constants/screens';
import { useHistory } from 'react-router-dom';
import { branchStore } from 'src/mobx/barnchStore';
import { TTranslate } from 'src/types/main';

interface IProps {
  amount: number;
  loading?: boolean;
  isCashbackPromocode?: boolean;
  isSettingsCashbackOn?: boolean;
  className?: string;
  name?: string | TTranslate;
  description?: string | TTranslate;
}

export const Cashback: React.FC<IProps> = ({
  loading = false,
  isSettingsCashbackOn = false,
  isCashbackPromocode = false,
  amount,
  className,
  name,
  description,
}) => {
  const history = useHistory();

  if (loading) {
    return <Skeleton className="product-submit-item" style={{ borderRadius: 12, height: 50 }} />;
  }

  const openTerms = () => {
    return history.push(SCREENS.TERMS());
  };

  return (
    <div className={className}>
      {amount ? (
        <div className={`cashback-cart-container ${className}`}>
          <div className="price-container cashbackName-price">
            <div className="cashback-name cashback-text-color">
              {name ? getTranslate(name) : localeStore.t('consumer_promocode_activated_cashback_header')}
            </div>
            <div className="price-container ">
              <img width="16" height="16" src={`${process.env.REACT_APP_CLOUD_FRONT}/media/images/cashback.svg`} />
              <div className="cashback-text-color cashbackPrice">{formatPrice(+amount, branchStore.currency)}</div>
            </div>
          </div>
          <div className="cashback-description cashback-text-color">
            {description
              ? `${getTranslate(description)}. `
              : `${localeStore.t('consumer_promocode_activated_cashback_description')} `}
            <a className="cashback-description terms-and-conditions cashback-text-color" href="#" onClick={openTerms}>
              {localeStore.t('consumer_promocode_activated_cashback_tc')}
            </a>
          </div>
        </div>
      ) : null}
      {isSettingsCashbackOn ? (
        <>
          <div className="infoTip-divider" />
          <div className="infoTip">
            {localeStore.t(isCashbackPromocode ? 'promocode_activated_cashback_with_offer' : 'cashback_with_promo')}
          </div>
        </>
      ) : null}
    </div>
  );
};
